module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Ladle-4ccdd3c44212bfd08a4e85fa76457d08.svg";